// 顾客课题组管理
import {contractApi} from "@/axios";
//获取客户课题组信息
export function getGroupPage(params,sendData){
    return contractApi({
        url:'/researchGroup/page',
        method:'post',
        data:sendData,
        params:params
    })
}
//获取单位所有课题组名称
export function getResearchGroupByCompanyId(id){
    return contractApi({
        url:'/researchGroup/groupName/' + id,
        method:'get'
    })
}
// 删除课题组信息
export function deletegroup(params){
    return contractApi({
        url:'/researchGroup',
        method:'delete',
        params: params
    })
}
//添加课题组信息
export function addGroup(data){
    return contractApi({
        url:'/researchGroup',
        method:'post',
        data:data
    })
}
//修改课题组信息
export function editGroup(data){
    return contractApi({
        url:'/researchGroup',
        method:'put',
        data:data
    })
}